import React, { useState } from 'react';
import styled from 'styled-components';
import cx from 'classnames';

const t = {
  impossible_times: 'Impossible times in drop-off',
  considered: '. You considered a loading + traveling time of ',
  minimum: ' but the minimum is ',
  shipper_not_validated:
    'It is not possible to create orders for this shipper because his payment method has not been validated by finance',
  credit_card:
    'It is not possible to create orders for this shipper because his payment method is credit card.',
};

function renderWarnings({ type, warnings }) {
  if (!['times', 'shipper'].includes(type)) return null;

  const warningTypes = {
    times: (warnings) => {
      return warnings?.map(({ stopKey, givenTime, realTime }) => {
        return `${t.impossible_times} ${stopKey}${t.considered}${givenTime}${t.minimum}${realTime}. \n`;
      });
    },
    shipper: (warnings) => {
      return warnings?.isNotValidated
        ? t.shipper_not_validated
        : warnings?.isCreditCard
        ? t.credit_card
        : '';
    },
  };

  return warningTypes[type](warnings);
}

const FormError = ({ type, warnings, className }) => {
  const [hidden, setHidden] = useState(false);
  const handleClick = () => setHidden(true);

  if (!warnings) return null;

  return (
    <div className={className}>
      <div className={cx({ hide: hidden, 'error-panel': true })} onClick={handleClick}>
        <div className="text">{renderWarnings({ warnings, type })}</div>
      </div>
    </div>
  );
};

export default styled(FormError)`
  z-index: 999;
  position: relative;
  bottom: -88%;

  .error-panel {
    width: 100%;
    min-height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.4rem;
    color: var(--grey900);
    background-color: var(--error100);
    z-index: 99;
    font-weight: bold;
    white-space: pre-wrap;

    &:hover {
      cursor: pointer;
    }
  }

  .text {
    padding: 1.6rem;
    max-height: 90%;
  }

  .hide {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    transition: all 1s ease-out;
  }
`;
